<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Mostrar
            <b-form-select
              v-model="table.perPage"
              size="sm"
              :options="table.pageOptions"
            />
            registros
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_filter text-md-right">
          <label class="d-inline-flex align-items-center">
            Pesquisar:
            <b-form-input
              type="search"
              class="form-control form-control-sm ml-2"
              placeholder="Pesquisar..."
              v-model="table.filter"
            />
          </label>
        </div>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="table-striped"
        :items="contratos"
        :fields="table.fields"
        responsive="sm"
        :per-page="table.perPage"
        :current-page="table.currentPage"
        :sort-by.sync="table.sortBy"
        :sort-desc.sync="table.sortDesc"
        :filter="table.filter"
        :filter-included-fields="table.filterOn"
        @filtered="onFiltered"
      >
        <template #cell(titulo)="row">
          <span v-html="row.value"></span>
        </template>
        <template #cell(data_inicio)="row">
          <span v-html="row.value" class="text-center"></span>
        </template>
        <template #cell(data_final)="row">
          <span v-html="row.value"></span>
        </template>
        <template #cell(parcelas_pagamento)="row">
          <span v-html="row.value"></span>
        </template>
        <template #cell(valor_total)="row">
          <span v-html="row.value"></span>
        </template>
        <template #cell(actions)="row">
          <button
            v-if="getModuleUserByCode('2.01.003')"
            type="button"
            class="btn btn-outline-secondary"
            title="Editar"
            @click="$emit('lancarContrato', row.item.id)"
          >
            Lançar
          </button>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col d-inline-flex align-items-center">
        Quantidade de registros: {{ contratos.length }}
        <span v-if="table.filter != null && table.filter != ''">
          &nbsp;(Filtrados: {{ table.totalRows }})
        </span>
      </div>
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-right">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="table.currentPage"
              :total-rows="table.totalRows"
              :per-page="table.perPage"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { moneyToCurrencyBr } from '@/utils/strings'
import { dateSqlToDateBR } from '@/utils/date'

export default {
  name: 'ListPreLancamento',

  props: {
    contratos: {
      type: Array,
      required: false,
    },
  },

  data() {
    return {
      table: {
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: 'titulo',
        sortDesc: false,
        fields: [
          {
            key: 'titulo',
            label: 'Lançamento',
            formatter: (value, key, item) => {
              return `<h6 class="d-none d-sm-inline-block text-bold">${item.id} - ${item.titulo}</h6> <br> ${item.name}`
            },
          },
          {
            key: 'data_inicio',
            label: 'Data Início',
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true,
            tdClass: 'text-center align-middle',
            thClass: 'text-center align-middle',
            formatter: (value, key, item) => {
              return `<h6 class="d-none d-sm-inline-block text-bold">${dateSqlToDateBR(
                item.data_inicio,
              )}</h6> <br> Início`
            },
          },
          {
            key: 'data_final',
            label: 'Data Final',
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true,
            tdClass: 'text-center align-middle',
            thClass: 'text-center align-middle',
            formatter: (value, key, item) => {
              return `<h6 class="d-none d-sm-inline-block text-bold">${dateSqlToDateBR(
                item.data_final,
              )}</h6> <br> Final`
            },
          },
          {
            key: 'parcelas_pagamento',
            label: 'Pagamento',
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true,
            tdClass: 'text-center align-middle',
            thClass: 'text-center align-middle',
            formatter: (value, key, item) => {
              return `<h6 class="d-none d-sm-inline-block text-bold"> ${item.parcelas_pagamento} vezes</h6> <br> ${item.forma_pagamento_descricao}`
            },
          },
          {
            key: 'valor_total',
            label: 'Valor',
            sortable: true,
            sortByFormatted: true,
            filterByFormatted: true,
            tdClass: 'text-center align-middle',
            thClass: 'text-center align-middle',
            formatter: (value, key, item) => {
              return `<h6 class="d-none d-sm-inline-block text-bold"> ${moneyToCurrencyBr(
                item.valor_contrato,
              )}</h6>`
            },
          },
          {
            key: 'actions',
            label: 'Ações',
            tdClass: 'text-center align-middle',
            thClass: 'text-center align-middle',
            thStyle: { width: '130px' },
          },
        ],
      },
    }
  },

  computed: {
    ...mapGetters(['getModuleUserByCode']),
  },

  methods: {
    onFiltered(filteredItems) {
      this.table.totalRows = filteredItems.length
      this.table.currentPage = 1
    },
  },

  mounted() {
    this.table.totalRows = this.contratos.length
  },
}
</script>
